import { render } from "./GeneralSelect.vue?vue&type=template&id=1d28d43e&scoped=true&ts=true"
import script from "./GeneralSelect.vue?vue&type=script&lang=ts"
export * from "./GeneralSelect.vue?vue&type=script&lang=ts"

import "./GeneralSelect.vue?vue&type=style&index=0&id=1d28d43e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d28d43e"]])

export default __exports__